module.exports = __webpack_public_path__ + "img/1.a1be97a0.png";